import React from "react";
import { ATVTemplateToken } from "../types";
import { ATVHeaderStd } from "./ATVHeaderStd/ATVHeaderStd";
import { ATVContainerStd } from "./ATVContainerStd/ATVContainerStd";
import { ATVRowStd } from "./ATVRowStd/ATVRowStd";

export const atvTokenStd: Required<ATVTemplateToken> = {
  header({ store, useSelection }, dynamicProps) {
    return (
      <ATVHeaderStd
        store={store}
        useSelection={useSelection}
        dynamicProps={dynamicProps}
      />
    );
  },
  container(_, children) {
    return <ATVContainerStd>{children}</ATVContainerStd>;
  },
  item({ store, onRowClick, useSelection }, row, rowKey, dynamicProps) {
    return (
      <ATVRowStd
        store={store}
        onClick={onRowClick}
        useSelection={useSelection}
        row={row}
        rowKey={rowKey}
        dynamicProps={dynamicProps}
      />
    );
  },
  footer() {
    return null;
  },
};
